export const exactPrice = [244, 245, 361, 487]; // список услуг, по которым цена считается точной
export const hideTireCount = [244, 361, 487]; // в каких случаях не показываем выбор количества колёс
